import React from "react";
import { Box, Typography, useTheme } from "@material-ui/core/index";
import { createStyles, makeStyles } from "@material-ui/core/styles/index";

const TitleBox = props => {
  const classes = styles();
  const theme = useTheme();
  const { title, greyBackground } = props;

  return (
    <Box
      className={classes.titleBox}
      style={{
        backgroundColor: greyBackground ? theme.palette.grey.main : null
      }}
      borderBottom={1}
    >
      <Typography className={classes.title}>{title}</Typography>
    </Box>
  );
};

const styles = makeStyles(theme =>
  createStyles({
    titleBox: {
      padding: 16,
      borderColor: theme.palette.grey.main
    },
    title: {
      fontSize: 14,
      color: theme.palette.primary.main,
      fontWeight: "500"
    }
  })
);

export default TitleBox;
